<template>
  <ExtraNationalityFields v-model="nationality" has-past>
    <AppRow>
      <NationalitySelect v-model="nationality.country" hide-hint />
      <ExtraNationalityEcquirySelect v-model="nationality.acquiry" />
    </AppRow>
    <v-expand-transition>
      <AppRow v-if="nationality.status == 'past'">
        <DatePicker
          v-if="nationality.acquiry != 'birth'"
          v-model="nationality.from"
          :label="$tt('extra_nationality.from')"
          past
        />
        <DatePicker v-model="nationality.until" :label="$tt('extra_nationality.until')" past />
      </AppRow>
    </v-expand-transition>
  </ExtraNationalityFields>
</template>

<script setup lang="ts">
import type { ExtraNationality } from '~/types';
const nationality = defineModel<ExtraNationality>({ required: true });
</script>